import { render, staticRenderFns } from "./TotalEntradasPorProvincia.vue?vue&type=template&id=690bd6d0"
import script from "./TotalEntradasPorProvincia.vue?vue&type=script&lang=js"
export * from "./TotalEntradasPorProvincia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports